module.exports = __webpack_public_path__ + "img/blue_check.575b4cf9.png";